Bingo.OnClickStopPropagation = {};

/**
 * Stops propagation on element click event
 * @param selector
 */
Bingo.OnClickStopPropagation.init = (selector) => {
    selector.on('click', (event) => {
        event.stopPropagation();
    });
};
